import React, { useState, useEffect } from "react";
import { Form, Typography, Divider, Checkbox, message, Spin } from "antd";
import { MailOutlined, LockOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import FormInput from "../FormInput";
import ButtonComponent from "../Button/Button";
import MainLayout from "../MainLayout/MainLayout";
import "../Login/Login.scss";
import { startMicrosoftLogin } from "../../modules/msalService";

const { Link, Title } = Typography;

const RoleLoginForm = ({ title, onFinishHandle, forgotPassword, isNewAccountCreateFlag, createNewAccount, onBack, hideSSOButton }) => {
    const [ssoConfig, setSsoConfig] = useState(null);
    const [ssoLoading, setSsoLoading] = useState(false);

    // Read the tenant config cached by LoginNewPage; if missing, skip silently
    useEffect(() => {
        try {
            const stored = localStorage.getItem("tenantInfo");
            if (stored) setSsoConfig(JSON.parse(stored));
        } catch (_) {}
    }, []);

    const handleMicrosoftLogin = async () => {
        setSsoLoading(true);
        try {
            await startMicrosoftLogin();
            // Browser navigates away to Microsoft. After auth (including MFA),
            // Microsoft redirects back to localhost:3000/. The Login.js useEffect
            // detects #code= in the URL and handles the rest.
        } catch (err) {
            setSsoLoading(false);
            message.error(err?.message || "Microsoft login failed. Please try again.");
        }
    };

    const onFinish = (values) => {
        onFinishHandle(values);
    };

    // hideSSOButton=true on Client portal — SSO is institutional-only
    const showMicrosoftButton = !hideSSOButton && ssoConfig?.SSOProvider === "Microsoft";

    return (
        <MainLayout>
            <div className="login-page createNewPasswordUser">
                <div className="login-card">
                    {onBack && (
                        <div style={{ marginBottom: 16 }}>
                            <ArrowLeftOutlined
                                onClick={onBack}
                                style={{ fontSize: 20, cursor: "pointer", color: "#fff" }}
                            />
                        </div>
                    )}
                    <Title level={1}>{title}</Title>
                    <p className="subtitle">
                        Sign in to access institutional infrastructure for private credit
                    </p>

                    <Form layout="vertical" onFinish={onFinish}>
                        <FormInput
                            label="Email Address"
                            name="email"
                            placeholder="Enter Email"
                            prefix={<MailOutlined />}
                            rules={[
                                { required: true, message: "Email is required" },
                                { type: "email", message: "Enter a valid email" },
                            ]}
                        />

                        <FormInput
                            label="Password"
                            name="password"
                            type="password"
                            placeholder="Enter Password"
                            prefix={<LockOutlined />}
                            rules={[
                                { required: true, message: "Password is required" },
                            ]}
                        />

                        <div className="remember-row">
                            {/* <Checkbox defaultChecked>Remember me</Checkbox> */}
                            <Link className="forgotPasswordLink" onClick={forgotPassword} style={{ marginLeft: "auto" }}>
                                Forgot password?
                            </Link>
                        </div>

                        <ButtonComponent
                            text="Sign In"
                            htmlType="submit"
                            className="primary-btn f16"
                        />
                    </Form>

                    <Divider className="loginOrDivider">or</Divider>

                    {isNewAccountCreateFlag &&
                        <ButtonComponent
                            text="Request Access"
                            className="secondary-btn f16"
                            type="default"
                            onClick={createNewAccount}
                        />}

                    <p className="contact-text">
                        Don't have access? <a style={{ color: "#fff" }} target="_blank" href="https://levridge.ai/contact">Contact our team</a>
                    </p>

                    {showMicrosoftButton && (
                        <>
                            <Divider style={{ borderColor: "rgba(255,255,255,0.25)", color: "rgba(255,255,255,0.6)", fontSize: 12 }}>
                                or sign in with
                            </Divider>
                            <Spin spinning={ssoLoading}>
                                <button
                                    type="button"
                                    onClick={handleMicrosoftLogin}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: 10,
                                        width: "100%",
                                        padding: "10px 16px",
                                        background: "#ffffff",
                                        color: "#333333",
                                        border: "none",
                                        borderRadius: 6,
                                        fontSize: 14,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        marginTop: 4,
                                    }}
                                >
                                    {/* Microsoft logo SVG */}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21">
                                        <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                                        <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                                        <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                                        <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                                    </svg>
                                    Sign in with Microsoft
                                </button>
                            </Spin>
                        </>
                    )}
                </div>
            </div>
        </MainLayout>
    );
};

export default RoleLoginForm;
